import { render } from "./highSeas.vue?vue&type=template&id=770350d2&scoped=true"
import script from "./highSeas.vue?vue&type=script&lang=js"
export * from "./highSeas.vue?vue&type=script&lang=js"

import "./highSeas.vue?vue&type=style&index=0&id=770350d2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-770350d2"

export default script